import { Checkbox, CheckboxProps, checkboxClasses } from "@mui/material";
import { withDisplayName } from "../../utils/displayName";

withDisplayName(Checkbox, "Checkbox");
export type { CheckboxProps, checkboxClasses };
export { Checkbox };

export const CheckboxSizes = ["small", "medium"] as const;
export type CheckboxSize = (typeof CheckboxSizes)[number];
